import { fork, put, select, takeLatest } from "redux-saga/effects";

import { getUserData } from "../login/selector";
import {
  handleInsufficientPermissionsRoutine,
  hasPermissionsAsyncRoutine
} from "./index";
import hasPermissionRedux from "./utils/hasPermissionRedux";

function* onHandleInsufficientPermissions({ payload }) {
  try {
    yield put(handleInsufficientPermissionsRoutine.success());
  } catch (e) {
    yield put(handleInsufficientPermissionsRoutine.failure(e));
  }
}

function* onHasPermissionsAsyncRoutine({ payload }) {
  try {
    const userData = yield select(getUserData);

    yield put(
      hasPermissionsAsyncRoutine.success(
        hasPermissionRedux({ userData })({
          permissions: payload
        })
      )
    );
  } catch (e) {
    console.error(e);
    yield put(hasPermissionsAsyncRoutine.failure(e));
  }
}

function* watchUserPermissionsActions() {
  yield takeLatest(
    handleInsufficientPermissionsRoutine.TRIGGER,
    onHandleInsufficientPermissions
  );
  yield takeLatest(
    hasPermissionsAsyncRoutine.TRIGGER,
    onHasPermissionsAsyncRoutine
  );
}

export default [fork(watchUserPermissionsActions)];
